"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollAreaTheme = void 0;
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
const scrollAreaTheme = (0, _sdsThemeInternal.themed)({
  keyline: {
    start: {
      boxShadow: {
        vertical: {
          rest: {
            "lodestar-light": `0 2px 0 0 ${(0, _designTokensReact.color)("color--border--neutral--default")}`,
            "ursa-light": `0 1px 0 0 var(--smar--sds--keyline--color, ${(0, _designTokensReact.color)("color--border--slate--weaker")})`
          },
          scrolling: {
            "lodestar-light": `0 2px 0 0 ${(0, _designTokensReact.color)("color--border--neutral--default")}`,
            "ursa-light": (0, _designTokensReact.color)("elevation--low")
          }
        },
        horizontal: {
          rest: {
            "lodestar-light": `2px 0 0 0 ${(0, _designTokensReact.color)("color--border--neutral--default")}`,
            "ursa-light": `1px 0 0 0 var(--smar--sds--keyline--color, ${(0, _designTokensReact.color)("color--border--slate--weaker")})`
          },
          scrolling: {
            "lodestar-light": `2px 0 0 0 ${(0, _designTokensReact.color)("color--border--neutral--default")}`,
            "ursa-light": "2px 0px 4px rgba(57, 61, 76, 0.16), 6px 0px 12px rgba(65, 80, 139, 0.12)"
          }
        }
      }
    },
    end: {
      boxShadow: {
        vertical: {
          rest: {
            "lodestar-light": `0 -2px 0 0 ${(0, _designTokensReact.color)("color--border--neutral--default")}`,
            "ursa-light": `0 -1px 0 0 var(--smar--sds--keyline--color, ${(0, _designTokensReact.color)("color--border--slate--weaker")})`
          },
          scrolling: {
            "lodestar-light": `0 -2px 0 0 ${(0, _designTokensReact.color)("color--border--neutral--default")}`,
            // Can't use this here since the y offset is negative.
            // color("elevation--low")
            "ursa-light": "0px -2px 4px rgba(57,61,76,0.16), 0px -6px 12px rgba(65,80,139,0.12)"
          }
        },
        horizontal: {
          rest: {
            "lodestar-light": `-2px 0 0 0 ${(0, _designTokensReact.color)("color--border--neutral--default")}`,
            "ursa-light": `-1px 0 0 0 var(--smar--sds--keyline--color, ${(0, _designTokensReact.color)("color--border--slate--weaker")})`
          },
          scrolling: {
            "lodestar-light": `-2px 0 0 0 ${(0, _designTokensReact.color)("color--border--neutral--default")}`,
            // Can't use this here since the y offset is negative.
            // color("elevation--low")
            "ursa-light": "-2px 0 4px rgba(57,61,76,0.16), 0px -6px 12px rgba(65,80,139,0.12)"
          }
        }
      }
    }
  }
});
exports.scrollAreaTheme = scrollAreaTheme;
//# sourceMappingURL=scrollAreaTheme.js.map